/**
 * Specifies the type of customer data that is blacklisted.
 */
export enum BlacklistedCustomerDataField {
    /**
     * Indicates that the customer's name is blacklisted.
     */
    Name = 1,

    /**
     * Indicates that the customer's address is blacklisted.
     */
    Address,

    /**
     * Indicates that the customer's IBAN (International Bank Account Number) is blacklisted.
     */
    IBAN,

    /**
     * Indicates that the customer's email address is blacklisted.
     */
    Email,

    /**
     * Indicates that the customer's number is blacklisted.
     */
    Number
}